import {useMount as _useMount} from 'react-use';
import utils from '@utils';

export const useMount = (props: any) => {
  _useMount(async () => {
    const query = utils.queryParams.parse(props.location.search);

    // ログイン前の場合、パラメーターを渡さないようにする
    let teamId: any;
    if (props.me.teamId) {
      teamId = props.me.teamId;
    } else {
      teamId = undefined;
    }

    await props.actions.notifications.getOneNotification({
      teamId,
      userNotificationId: query.id,
    });
  });
};
